import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    if (error.message.includes('ResizeObserver loop limit exceeded')) {
      return null; // Ignore ResizeObserver errors
    }
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Ignore ResizeObserver errors
    if (error.message.includes('ResizeObserver loop limit exceeded')) {
      return;
    }
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;